import React, {Component} from 'react';
import {Button} from '@homeaway/react-buttons';
import Modal from '@homeaway/react-modal';
import edap from '../edap';
import {withTranslationsAsProps} from '../../../components/translations';
import './invalid-invite-modal.less';

// Modal will pop and fire edap on mount -- conditionally render in containing component!
export class InvalidInviteModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: true // pop on creation
        };
    }

    componentDidMount = () => {
        edap.invalidInviteModalPop(this.props.inviteId);
    };

    handleClose = () => {
        edap.invalidInviteModalClose(this.props.inviteId);
        this.setState({
            isOpen: false
        });
    };

    render() {
        const {buttonText, messageText, titleText} = this.props;

        return (
            <Modal id={'invalid-invite-modal'} isOpen={this.state.isOpen} onClose={this.handleClose} title={titleText}>
                <p>{messageText}</p>
                <div className="invalid-invite-modal__button">
                    <Button label={buttonText} onClick={this.handleClose} />
                </div>
            </Modal>
        );
    }
}

export default withTranslationsAsProps({
    'tripboards.main.expired.ok': 'buttonText',
    'tripboards.main.expired': 'messageText',
    'tripboards.main.expired.title': 'titleText'
})(InvalidInviteModal);



// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/components/invalid-invite-modal.js